import compose from 'lodash/fp/compose';
import { shape, string } from 'prop-types';
import React from 'react';

import ListAgreements from '../agreements/ListAgreements';
import ListCategorizedCampaigns from '../campaigns/ListCategorizedCampaigns';
import { withDocumentTitle } from '../generic/DocumentTitle';
import ScopedDrawer, { changelog } from '../generic/ScopedDrawer';
import ListCategorizedOpportunities from '../opportunities/ListCategorizedOpportunities';
import withResolved from '../REST/with-resolved';
import BrandInfo from './BrandInfo';
import { getTransformedBrand } from './transform-brand-helpers';

export const ResolvedBrandInfo = compose(
  withResolved({
    query: getTransformedBrand,
    deriveQueryArgs: ({ id }) => ({ id }),
    as: 'model',
  }),
  withDocumentTitle(({ model }) => model.name),
)(BrandInfo);

function ShowBrand({ match }) {
  const brandId = Number.parseInt(match.params.id, 10);
  const context = { contentType: 'brand', objectId: brandId };
  return (
    <>
      <div className="mb-4">
        <ScopedDrawer options={[changelog(context)]}>
          <ResolvedBrandInfo id={brandId} />
        </ScopedDrawer>
      </div>

      <div className="mb-4">
        <ListAgreements brandIds={[brandId]} titleSize="sm" />
      </div>

      <div className="mb-4">
        <ListCategorizedOpportunities
          brandIds={[brandId]}
          hiddenColumns={['Brands']}
          titleSize="sm"
        />
      </div>

      <div className="mb-4">
        <ListCategorizedCampaigns
          brandIds={[brandId]}
          hiddenColumns={['Brand', 'Owner']}
          titleSize="sm"
        />
      </div>
    </>
  );
}

ShowBrand.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
};

export default ShowBrand;
